__turbopack_context__.v({
  "dot": "loadingTitleDots-module__9svIKW__dot",
  "dots": "loadingTitleDots-module__9svIKW__dots",
  "loadingTitleDotPulse": "loadingTitleDots-module__9svIKW__loadingTitleDotPulse",
});
